import { FunctionBlockUiState } from '@/store/modules/functionBlockUi/types'
import { MutationTree } from 'vuex'

export const mutations: MutationTree<FunctionBlockUiState> = {
}